<template>
  <div>
    <v-row justify="center">
      <v-col cols="12" sm="11" md="10" lg="8" xl="6">
        <v-card>
          <!-- Header Section -->
          <v-col
            cols="12"
            style="background-color: #f96654"
            class="d-flex flex-column flex-sm-row align-center pa-4"
          >
            <div class="d-flex justify-center justify-sm-start mb-2 mb-sm-0">
              <img
                :src="require('../../assets/Dynamic_Pricing.svg')"
                :width="$vuetify.breakpoint.xs ? '180' : '220'"
                style="max-width: 100%; height: auto"
              />
            </div>
            <v-spacer class="d-none d-sm-flex"></v-spacer>
            <span v-if="plan.length" @click="showPlansModal" class="mt-2 mt-sm-0">
              <badge style="cursor: pointer" small="true" :text="plan" color="white" />
            </span>
          </v-col>

          <v-card-text class="pa-2 pa-sm-4">
            <v-form ref="subscription_form" id="subscription_form" lazy-validation>
              <v-row>
                <!-- Sign Up Section -->
                <v-col
                  cols="12"
                  md="5"
                  class="pa-4 pa-sm-6 pa-md-8"
                  :style="
                    $vuetify.breakpoint.mdAndUp
                      ? 'border-right: 1px solid rgba(181, 181, 181, 0.2)'
                      : 'border-bottom: 1px solid rgba(181, 181, 181, 0.2)'
                  "
                >
                  <div class="mb-8">
                    <h2 class="text-h5 text-sm-h4 font-weight-bold">Sign Up</h2>
                  </div>

                  <v-row>
                    <v-col cols="12" class="py-2">
                      <v-text-field
                        v-model="name"
                        label="Full name *"
                        :rules="[rules.required]"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" class="py-2">
                      <v-text-field
                        autocomplete="on"
                        ref="email_crawlo"
                        v-model="email"
                        :rules="[rules.required, rules.emailValidation]"
                        label="Email *"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" class="py-2">
                      <v-text-field
                        v-model="password"
                        :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required, rules.min]"
                        label="Password *"
                        hint="At least 8 characters"
                        counter
                        :type="show_password ? 'text' : 'password'"
                        @click:append="show_password = !show_password"
                        @focus="show_indecator = true"
                        @blur="show_indecator = false"
                        :loading="show_indecator"
                        name="crawlo_password"
                        outlined
                        dense
                      >
                        <template v-slot:progress v-if="show_indecator">
                          <v-progress-linear
                            :value="progress"
                            :color="password_color"
                            absolute
                            height="7"
                          >
                          </v-progress-linear>
                        </template>
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" class="py-2">
                      <v-text-field
                        :append-icon="show_password_conf ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[(v) => v === password || 'Password do not match', rules.required]"
                        label="Confirm password *"
                        hint="At least 8 characters"
                        :type="show_password_conf ? 'text' : 'password'"
                        @click:append="show_password_conf = !show_password_conf"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" class="py-2">
                      <v-checkbox :rules="[rules.required]" required v-model="conditions">
                        <template v-slot:label>
                          <div @click.stop="" class="text-body-2">
                            I accept the &nbsp;
                            <a href="/Privacy" target="_blank" style="color: #42b983">
                              Privacy Policy
                            </a>
                            &nbsp;and the&nbsp;
                            <a href="/TermsConditions" target="_blank" style="color: #42b983">
                              Legal Notice</a
                            >
                          </div>
                        </template>
                      </v-checkbox>
                    </v-col>

                    <v-col cols="12" class="py-2">
                      <v-btn
                        text
                        color="primary"
                        @click="gotoLogin()"
                        class="text-none mb-4"
                        :small="$vuetify.breakpoint.xs"
                      >
                        <v-icon left small>$back</v-icon> Sign In
                      </v-btn>
                    </v-col>

                    <v-col cols="12">
                      <v-btn
                        :large="!$vuetify.breakpoint.xs"
                        block
                        color="error"
                        :loading="submit_loading"
                        @click="validateSubscription"
                        class="text-none"
                      >
                        Get Started !
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <!-- Business Information Section -->
                <v-col cols="12" md="7" class="pa-4 pa-sm-6 pa-md-8" >
                  <div class="mb-8">
                    <h2 class="text-h5 text-sm-h4 font-weight-bold">Business Information</h2>
                  </div>
                  <v-row>
                    <v-col cols="12" class="py-2">
                      <v-text-field
                        v-model="company"
                        :rules="[]"
                        label="Company"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="py-2 mt-4" hidden>
                      <v-btn
                        color="error"
                        block
                        @click="showPlansModal"
                        :large="!$vuetify.breakpoint.xs"
                        class="text-none"
                      >
                        Change your plan
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Error Messages -->
      <v-col cols="12" class="d-flex justify-center">
        <div style="width: 100%; max-width: 500px">
          <v-alert
            v-for="error in errors"
            :key="error"
            color="error"
            dark
            border="left"
            icon="mdi-alert"
            transition="scale-transition"
            class="mb-2"
          >
            {{ error.message }}
          </v-alert>
        </div>
      </v-col>
    </v-row>

    <!-- Plans Modal -->
    <v-dialog
      v-model="dialog"
      :max-width="$vuetify.breakpoint.xs ? '95%' : $vuetify.breakpoint.sm ? '85%' : '70%'"
      :fullscreen="$vuetify.breakpoint.xs"
    >
      <v-card>
        <v-card-title class="px-4 px-sm-6">
          <span class="text-h6 text-sm-h5">Choose a plan</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="px-4 px-sm-6">
          <plans @choosen-plan="choosenPlan" />
        </v-card-text>

        <v-card-actions class="px-4 px-sm-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false" :small="$vuetify.breakpoint.xs">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { loadStripe } from '@stripe/stripe-js'
  import plans from '../common/plans.vue'
  import axios from 'axios'

  export default {
    name: 'Subscription',
    components: {
      plans,
    },
    props: {
      msg: String,
    },
    data: () => ({
      dialog: false,
      alert: true,
      conditions: '',
      name: '',
      email: '',
      password: '',
      show_indecator: false,
      website: '',
      zip: '',
      city: '',
      adress: '',
      company: '',
      country: '',
      tax: '',
      errors: [],
      selected_plan: '',
      count: 20,
      availabl_plans: [
        process.env.VUE_APP_PLAN_BUSINESS.replace('price_', ''), //business
        process.env.VUE_APP_PLAN_PROFESSIONAL.replace('price_', ''), //professional
        process.env.VUE_APP_PLAN_STARTER.replace('price_', ''), //starter
        process.env.VUE_APP_PLAN_TRIAL.replace('price_', ''), //trial
      ],
      plansNames: {
        price_1S66EgKBQj3UOQ3bEs3RPmH9: 'BUSINESS / 199€',
        price_1S66EIKBQj3UOQ3bYviabrIv: 'PROFESSIONAL / 99€',
        price_1S66CnKBQj3UOQ3boSv2OPXS: 'STARTER / 49€',
        price_1SPKvnKBQj3UOQ3bBgyjclMH: 'TRIAL / 0€',
      },
      loading: false,
      checkout_session_id: '',
      publishableKey: process.env.VUE_APP_PK_STRIPE_KEY,
      show_password: false,
      show_password_conf: false,
      submit_loading: false,
      countries: [
        'Afghanistan',
        'Albania',
        'Algeria',
        'Andorra',
        'Angola',
        'Anguilla',
        'Antigua &amp; Barbuda',
        'Argentina',
        'Armenia',
        'Aruba',
        'Australia',
        'Austria',
        'Azerbaijan',
        'Bahamas',
        'Bahrain',
        'Bangladesh',
        'Barbados',
        'Belarus',
        'Belgium',
        'Belize',
        'Benin',
        'Bermuda',
        'Bhutan',
        'Bolivia',
        'Bosnia &amp; Herzegovina',
        'Botswana',
        'Brazil',
        'British Virgin Islands',
        'Brunei',
        'Bulgaria',
        'Burkina Faso',
        'Burundi',
        'Cambodia',
        'Cameroon',
        'Cape Verde',
        'Cayman Islands',
        'Chad',
        'Chile',
        'China',
        'Colombia',
        'Congo',
        'Cook Islands',
        'Costa Rica',
        'Cote D Ivoire',
        'Croatia',
        'Cruise Ship',
        'Cuba',
        'Cyprus',
        'Czech Republic',
        'Denmark',
        'Djibouti',
        'Dominica',
        'Dominican Republic',
        'Ecuador',
        'Egypt',
        'El Salvador',
        'Equatorial Guinea',
        'Estonia',
        'Ethiopia',
        'Falkland Islands',
        'Faroe Islands',
        'Fiji',
        'Finland',
        'France',
        'French Polynesia',
        'French West Indies',
        'Gabon',
        'Gambia',
        'Georgia',
        'Germany',
        'Ghana',
        'Gibraltar',
        'Greece',
        'Greenland',
        'Grenada',
        'Guam',
        'Guatemala',
        'Guernsey',
        'Guinea',
        'Guinea Bissau',
        'Guyana',
        'Haiti',
        'Honduras',
        'Hong Kong',
        'Hungary',
        'Iceland',
        'India',
        'Indonesia',
        'Iran',
        'Iraq',
        'Ireland',
        'Isle of Man',
        'Israel',
        'Italy',
        'Jamaica',
        'Japan',
        'Jersey',
        'Jordan',
        'Kazakhstan',
        'Kenya',
        'Kuwait',
        'Kyrgyz Republic',
        'Laos',
        'Latvia',
        'Lebanon',
        'Lesotho',
        'Liberia',
        'Libya',
        'Liechtenstein',
        'Lithuania',
        'Luxembourg',
        'Macau',
        'Macedonia',
        'Madagascar',
        'Malawi',
        'Malaysia',
        'Maldives',
        'Mali',
        'Malta',
        'Mauritania',
        'Mauritius',
        'Mexico',
        'Moldova',
        'Monaco',
        'Mongolia',
        'Montenegro',
        'Montserrat',
        'Morocco',
        'Mozambique',
        'Namibia',
        'Nepal',
        'Netherlands',
        'Netherlands Antilles',
        'New Caledonia',
        'New Zealand',
        'Nicaragua',
        'Niger',
        'Nigeria',
        'Norway',
        'Oman',
        'Pakistan',
        'Palestine',
        'Panama',
        'Papua New Guinea',
        'Paraguay',
        'Peru',
        'Philippines',
        'Poland',
        'Portugal',
        'Puerto Rico',
        'Qatar',
        'Reunion',
        'Romania',
        'Russia',
        'Rwanda',
        'Saint Pierre &amp; Miquelon',
        'Samoa',
        'San Marino',
        'Satellite',
        'Saudi Arabia',
        'Senegal',
        'Serbia',
        'Seychelles',
        'Sierra Leone',
        'Singapore',
        'Slovakia',
        'Slovenia',
        'South Africa',
        'South Korea',
        'Spain',
        'Sri Lanka',
        'St Kitts &amp; Nevis',
        'St Lucia',
        'St Vincent',
        'St. Lucia',
        'Sudan',
        'Suriname',
        'Swaziland',
        'Sweden',
        'Switzerland',
        'Syria',
        'Taiwan',
        'Tajikistan',
        'Tanzania',
        'Thailand',
        "Timor L'Este",
        'Togo',
        'Tonga',
        'Trinidad &amp; Tobago',
        'Tunisia',
        'Turkey',
        'Turkmenistan',
        'Turks &amp; Caicos',
        'Uganda',
        'Ukraine',
        'United Arab Emirates',
        'United Kingdom',
        'United States',
        'Uruguay',
        'Uzbekistan',
        'Venezuela',
        'Vietnam',
        'Virgin Islands (US)',
        'Yemen',
        'Zambia',
        'Zimbabwe',
      ],
      rules: {
        required: (value) => !!value || 'This field is required.',
        min: (v) => v.length >= 8 || 'Min 8 characters',
        emailValidation: (value) => /.+@.+\..+/.test(value) || 'Email not valid.',
      },
      plan: '',
      password_color: 'error',
    }),
    computed: {
      progress() {
        return Math.min(100, this.count)
      },
    },
    methods: {
      alertMessage(error) {
        return error.message.replace(error.field, `<strong>${error.field}</strong>`)
      },
      choosenPlan(plan) {
        console.log('choosen plan from parent : ', plan)
        this.selected_plan = this.availabl_plans[plan]
      },
      showPlansModal() {
        this.dialog = true
      },
      clearErrors() {
        this.errors = []
      },
      validateSubscription() {
        let dataToSubmit = {}
        if (this.$refs.subscription_form.validate() && this.selected_plan) {
          this.submit_loading = true
          dataToSubmit.fullname = this.name
          dataToSubmit.email = this.email
          dataToSubmit.password = this.password
          dataToSubmit.company = this.company
          dataToSubmit.adress = this.adress
          dataToSubmit.city = this.city
          dataToSubmit.zip = this.zip
          dataToSubmit.country = this.country
          dataToSubmit.conditions = this.conditions ? 'accept' : ''

          if (this.tax.length) dataToSubmit.tax = this.tax
          if (this.selected_plan) this.newCustomer(dataToSubmit)
        }
      },
      async checkoutStripe() {
        const stripe = await loadStripe(process.env.VUE_APP_PK_STRIPE_KEY)
        const { error } = await stripe.redirectToCheckout({
          sessionId: this.checkout_session_id,
        })
      },
      gotoLogin() {
        this.$router.push('/login')
      },
      getFieldError(field) {
        const error = this.errors.filter((err) => {
          return err.field == field
        })
        return error.length ? error[0].message : ''
      },
      async newCustomer(dataToSubmit) {
        this.errors = []
        await axios
          .post('/api/customer/new', {
            ...dataToSubmit,
            plan: this.selected_plan,
          })
          .then((res) => {
            if (res.data.errors && res.data.errors.length) this.errors = res.data.errors
            else this.$router.push({ path: '/login' })
          })
          .catch(() => {
            this.errors.push({ message: 'An error occurred. Please try again later.' ,field: ''})
          })
          .finally(() => {
            this.submit_loading = false
          })
      },
    },
    mounted() {
      console.log('query subscription : ', this.$route.query.p)
      this.selected_plan = this.$route.query.p || this.availabl_plans[1]
    },
    watch: {
      selected_plan: {
        handler() {
          this.plan = this.plansNames[`price_${this.selected_plan}`] || ''
        },
      },
      password: {
        handler() {
          this.count = 20
          if (this.password != undefined) {
            if (8 <= this.password.length && this.password.length <= 32) {
              if (RegExp('.*\\d.*').test(this.password)) this.count += 20
              if (RegExp('.*[a-z].*').test(this.password)) this.count += 20
              if (RegExp('.*[A-Z].*').test(this.password)) this.count += 20
              if (RegExp('(?=.*[!@#\\$%\\^&\\*])(?=.{8,})').test(this.password)) this.count += 20
            }
          }
          this.password_color =
            this.count <= 40
              ? 'error'
              : this.count == 60
              ? 'warning'
              : this.count == 80
              ? 'light-blue'
              : 'success'
        },
      },
    },
  }
</script>

<style scoped>
  a {
    color: #42b983;
  }
</style>
